import { FTProcess } from "@/models/FTProcess";
import { GoodsObject } from "@/models/GoodsObject";
import _ from "lodash";

export function orderFg({goods, processes}: { goods: GoodsObject[], processes: FTProcess[]}): GoodsObject | null {
  const finalProcess = processes.find((process: FTProcess) => process.type == 'Trading' || process.type == 'Packing');
  if(!finalProcess) return null;
  const orderFg = goods.find((good: GoodsObject) => good._id == _.get(finalProcess, 'outputs[0]._id', false));
  return orderFg || null;
}